import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const addToFavtTutorSuccess = (data) => {
  return {
    type: actionTypes.ADD_TO_FAVT_TUTOR,
    payload: {
      tutor: data.Data,
    },
  };
};

export const addToFavtTutor = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/AddTutorToFavourite`, data)
    .then((response) => {
      if (response) {
        dispatch(addToFavtTutorSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};